import SubtitleVideoLocalization from './SubtitleVideoLocalization.vue';

export default {
  SubtitleVideoLocalization,
};
